import { render, staticRenderFns } from "./DialogUserAutocompleteMultiple.vue?vue&type=template&id=088d9c21"
import script from "./DialogUserAutocompleteMultiple.vue?vue&type=script&lang=js"
export * from "./DialogUserAutocompleteMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports